<app-breadcrumb [title]="'Siniestros Viales'" [items]="['Seguridad Vial']"
  [active_item]="'Siniestros Viales'"></app-breadcrumb>

<div class="container-fluid">
  <div class="card">
    <div class="card-header d-flex align-items-center bg-primary text-white">
      <i class="icofont icofont-warning-alt me-2"></i>
      <h5 class="mb-0"><strong>LISTADO DE SINIESTROS VIALES</strong></h5>
    </div>

    <div class="card-body custom-datatable noscroll">
      <!-- Buscador -->
      <div class="row mb-12">
        <div class="col-sm-12 col-md-3 ms-auto">
          <div class="input-group">
            <input type="text" class="form-control" placeholder="Buscar por placa..." [(ngModel)]="searchText"
              (input)="filterData()" />
            <span class="input-group-text">
              <i class="fa fa-search"></i>
            </span>
          </div>
        </div>
      </div>

      <!-- Tabla -->
      <div class="custom-datatable table-responsive mt-4">
        <table class="table table-hover table-bordered" id="tblSiniestros">
          <thead class="bg-primary">
            <tr>
              <th class="text-center"><strong>CONSECUTIVO</strong></th>
              <th class="text-center"><strong>FECHA SINIESTRO</strong></th>
              <th class="text-center"><strong>HORA SINIESTRO</strong></th>
              <th class="text-center"><strong>PLACA</strong></th>
              <th class="text-center"><strong>TIPO SINIESTRO</strong></th>
              <th class="text-center"><strong>SEVERIDAD</strong></th>
              <th class="text-center"><strong>LESIONADOS</strong></th>
              <th class="text-center"><strong>FALLECIDOS</strong></th>
              <th class="text-center"><strong>VICTIMAS</strong></th>
              <th class="text-center"><strong>DESCRIPCIÓN</strong></th>
              <th class="text-center"><strong>ESTADO</strong></th>
              <th class="text-center"><strong>OPCIONES</strong></th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let siniestro of filteredTableItems | paginate: { itemsPerPage: pageSize1, currentPage: page1 }">
              <td class="text-center">{{ siniestro.consecutivo }}</td>
              <td class="text-center">{{ siniestro.fecha_siniestro | date:'dd/MM/yyyy' }}</td>
              <td class="text-center">{{ siniestro.hora_siniestro }}</td>
              <td class="text-center">{{ siniestro.placa }}</td>
              <td class="text-center">{{ siniestro.tipoSiniestroData?.nombre }}</td>
              <td class="text-center">{{ siniestro.nivelSeveridadData?.nombre }}</td>
              <td class="text-center">{{ siniestro.lesionados }}</td>
              <td class="text-center">{{ siniestro.fatalidad }}</td>
              <td class="text-center">{{ siniestro.numero_victimas }}</td>
              <td class="text-justify">{{ siniestro.descripcion_ocurrido }}</td>
              <td class="text-center">
                <span class="badge" [ngClass]="'bg-' + siniestro.estado_color">
                  {{ siniestro.estado_label }}
                </span>
              </td>
              <td class="text-center">
                <div class="action text-center">
                  <ul class="list-inline d-flex justify-content-center gap-3">
                    <!-- Mostrar editar solo si está activo -->
                    <li class="list-inline-item edit" *ngIf="siniestro.estado === 1">
                      <a href="javascript:void(0)" (click)="editarSiniestro(siniestro)">
                        <i class="icon-pencil-alt" ngbTooltip="Editar"></i>
                      </a>
                    </li>
                    <!-- Botón dinámico: Inactivar si activo, Activar si inactivo -->
                    <li class="list-inline-item delete">
                      <a href="javascript:void(0)">
                        <i class="icon-trash text-danger" *ngIf="siniestro.estado === 1"
                          (click)="inactivarSiniestro(siniestro)" ngbTooltip="Inactivar"></i>
                      </a>
                    </li>
                    <li class="list-inline-item edit">
                      <a href="javascript:void(0)">
                        <i class="icon-check text-success" *ngIf="siniestro.estado === 0"
                          (click)="activarSiniestro(siniestro)" ngbTooltip="Activar"></i>
                      </a>
                    </li>

                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Paginación y exportación -->
      <div class="row align-items-center mt-4 g-2">
        <div class="col-12 col-md-4 d-flex align-items-center">
          <label for="pageSize1" class="me-2 mb-0">Mostrar:</label>
          <select id="pageSize1" class="form-select w-auto" [(ngModel)]="pageSize1" (change)="page1 = 1">
            <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
          </select>
          <span class="ms-2">registros por página</span>
        </div>

        <div class="col-12 col-md-4 text-center">
          <span class="badge bg-primary ms-1"><b>Total Registros: {{ siniestros.length || 0 }}</b></span>
        </div>

        <div class="col-12 col-md-4 text-center text-md-end">
          <pagination-controls (pageChange)="page1 = $event" [maxSize]="5" [directionLinks]="true" [autoHide]="true"
            previousLabel="Anterior" nextLabel="Siguiente">
          </pagination-controls>
        </div>
      </div>

      <div class="card-body">
        <div class="btn-showcase text-center">
          <button class="btn btn-outline-success-2x" (click)="exportarExcel('tblSiniestros','Listado_Siniestros')">
            <i class="icofont icofont-file-excel"></i> EXCEL
          </button>
          <button class="btn btn-outline-danger-2x"
            (click)="exportToPDF('tblSiniestros','Listado_Siniestros','Listado de Siniestros Viales')">
            <i class="icofont icofont-file-pdf"></i> PDF
          </button>
        </div>
      </div>
    </div>
  </div>
</div>